'use client';

import {MutableRefObject, RefObject, useEffect} from 'react';
import {useForwardingRef} from './useForwardingRef';

interface Props<T> {
	onCatch?: () => void;
	ref?: RefObject<T>;
}

export const useCatchOutsidedClick = <T extends HTMLElement>({
	onCatch,
	ref: initialRef,
}: Props<T>): MutableRefObject<T> => {
	const ref = useForwardingRef(initialRef);

	useEffect(() => {
		if (!onCatch) {
			return;
		}

		const handleClose = (event: MouseEvent) => {
			const target = event.target as HTMLElement;

			if (ref.current && !ref.current.contains(target)) {
				onCatch();
			}
		};

		document.addEventListener('click', handleClose, true);

		return () => {
			document.removeEventListener('click', handleClose, true);
		};
	}, [onCatch]);

	return ref as MutableRefObject<T>;
};
